import React from "react";
import { IconSquareX } from "@tabler/icons-react";

const Base64ViewerComp = ({ link, close }) => {
  // console.log(link);
  return (
    <>
      <div style={styles.modalOverlay}>
        <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
          <div className="d-flex justify-content-end">
            <button className="btn btn-sm btn-danger mb-3" onClick={close}>
              <IconSquareX stroke={2} />
            </button>
          </div>
          <iframe src={`${link}`} title="Base64 File" style={styles.iframe} />
        </div>
      </div>
    </>
  );
};

// Inline styles
const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    width: "80%",
    maxHeight: "80%",
    overflow: "auto",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    padding: "5px 10px",
    fontSize: "16px",
    cursor: "pointer",
  },
  image: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
  iframe: {
    width: "100%",
    height: "500px",
  },
};

export default Base64ViewerComp;
